import { EnvelopeWithStatus } from 'types/Envelope';
import { envelopeStatus } from 'modules/envelopes/components/EnvelopesTable/envelopeStatus';

type EnvelopeStatusData = {
  statusValue: keyof typeof envelopeStatus;
  statusLabel: string;
  statusBadge: string;
  statusIcon: string;
};

export const getEnvelopeStatusData = (
  envelope: EnvelopeWithStatus
): EnvelopeStatusData => {
  const status = (envelope?.envelopeStatus?.envelopeStatus ||
    '_nostatus') as keyof typeof envelopeStatus;

  const statusData = envelopeStatus[status as keyof typeof envelopeStatus];

  const { statusValue, statusLabel, statusBadge, statusIcon } = {
    statusValue: status,
    statusLabel: statusData.label,
    statusBadge: statusData.badge,
    statusIcon: statusData.icon,
  };

  return { statusLabel, statusBadge, statusIcon, statusValue };
};
